import { axios } from '@/libs/api.request';
import { Response } from '@/types/request.d';

// 获取公司列表
export const getCompanyList = (name?: string) => {
    const params: any = {
        page: 1,
        page_size: 50,
    };
    if (name && name.trim()) {
        params.company_name = name.trim();
    }
    return axios.request({
        url: 'sys/company/company/get-company-list',
        method: 'get',
        params,
    });
};

// 获取用户列表
export const getPersonList = (email?: string) => {
    const params: any = {
        page: 1,
        page_size: 50,
    };
    if (email && email.trim()) {
        params.user_email = email.trim();
    }
    return axios.request({
        url: 'sys/company/company/get-user-list',
        method: 'get',
        params,
    });
};

interface PackageInfo {
    type: string;
    packageType?: string;
    companyType?: string;
    expireDate?: string;
    couponCode?: string;
    extraUserNum: string;
}
// 获取套餐信息 : http://yapi.xmp.one/project/27/interface/api/1398
export const packageInfo = (data: PackageInfo) => {
    const newData: any = {
        type: data.type,
        company_type: data.companyType || '',
        expire_date: data.expireDate || '',
        coupon_code: data.couponCode || '',
        extra_user_num: data.extraUserNum,
    };
    // 长期套餐时，不传 packageType
    if (data.packageType) {
        newData.package_type = data.packageType;
    }
    return axios.request({
        url: 'sys/company/company/package-info',
        method: 'post',
        data: newData,
    });
};

interface PurchasePackage {
    type: string;
    packageType?: string;
    companyType?: string;
    projectName?: string;
    contact?: string;
    userNum?: string;
    productName?: string;
    currencyCode: string;
    payChannelName: string;
    paymentChannelName: string;
    payType: string;
    packageMonth?: string;
    trailDay?: string;
    qq?: string;
    skype?: string;
    wechat?: string;
    extraUserNum: string;
    couponCode?: string;
    expireDate?: string;
}

// 更改套餐 : http://yapi.xmp.one/project/27/interface/api/1419
export const updatePackage = (data: PurchasePackage) => {
    const newData: any = {
        package_type: data.packageType,
        // expire_date: data.expireDate || '',
        coupon_code: data.couponCode || '',
        extra_user_num: data.extraUserNum,
        currency_code: data.currencyCode,
        pay_type: data.payType,
        payment_channel_name: data.paymentChannelName,
        pay_channel_name: data.payChannelName || data.paymentChannelName,
    };
    return axios.request({
        url: 'sys/company/company/update-package',
        method: 'post',
        data: newData,
    });
};

// 新购买套餐 : http://yapi.xmp.one/project/27/interface/api/1401
export const purchasePackage = (data: PurchasePackage) => {
    const newData: any = {};
    if (data.type) {
        newData.type = data.type;
    }
    if (data.contact) {
        newData.contact = data.contact;
    }
    if (data.packageType) {
        newData.package_type = data.packageType;
    }
    if (data.companyType) {
        newData.company_type = data.companyType;
    }
    if (data.projectName) {
        newData.project_name = data.projectName;
    }
    if (data.userNum) {
        newData.user_num = data.userNum;
    }
    if (data.productName) {
        newData.product_name = data.productName;
    }
    if (data.currencyCode) {
        newData.currency_code = data.currencyCode;
    }
    if (data.paymentChannelName) {
        newData.payment_channel_name = data.paymentChannelName;
    }

    newData.pay_channel_name = data.payChannelName || data.paymentChannelName; // 支付的细分类型，为空时就传 支付类型

    if (data.payType) {
        newData.pay_type = data.payType;
    }
    if (data.packageMonth) {
        newData.package_month = data.packageMonth;
    }
    if (data.trailDay) {
        newData.trail_day = data.trailDay;
    }
    if (data.expireDate) {
        newData.expire_date = data.expireDate;
    }
    if (data.qq) {
        newData.qq = data.qq;
    }
    if (data.skype) {
        newData.skype = data.skype;
    }
    if (data.wechat) {
        newData.wechat = data.wechat;
    }
    if (data.extraUserNum) {
        newData.extra_user_num = data.extraUserNum;
    }
    if (data.couponCode) {
        newData.coupon_code = data.couponCode;
    }
    return axios.request({
        url: '/sys/company/company/purchase-package',
        method: 'post',
        data: newData,
    });
};

// 超级管理员切换个人
export const setPersonAdmin = (userId: string) => axios.request({
    url: 'sys/company/company/set-user-admin',
    method: 'post',
    data: {
        user_id: userId,
    },
});

// 超级管理员切换公司
export const setCompanyAdmin = (projectId: string) => axios.request({
    url: 'sys/company/company/set-company-admin',
    method: 'post',
    data: {
        project_id: projectId,
    },
});

export const getTurnover = (page: number = 1, pageSize: number = 20, date: string = 'ALL') => axios.request({
    url: 'sys/admin/company/get-turnover',
    method: 'get',
    params: {
        page,
        page_size: pageSize,
        date,
    },
});

// 获取汇率信息
export const getRate = () => axios.request({
    url: 'sys/company/company/get-company-config',
    method: 'get',
});

interface Pay {
    money: string;
    email?: string;
    userId: string;
    projectId: string;
    paymentChannelName: string;
    payType?: string;
    payChannelName?: string;
}

interface Witdhdraw {
    type: string;
    money: string;
    projectName?: string;
    alipayAccountNumber?: string;
    alipayName?: string;
    administratorsEmail?: string;
}

// 充值下单
export const submitPay = ({
    money, email, userId, projectId, paymentChannelName, payType, payChannelName,
}: Pay) => {
    const data: any = {
        money,
        product_name: 'AdsPower',
        currency_code: 'USD',
        payment_channel_name: paymentChannelName || 'wechat',
        pay_type: payType || 'wechat',
        pay_channel_name: payChannelName || '',
    };
    let url = 'fbcc/order/create';
    // 未登录时，才需要传 email, userId, projectId
    if (email) {
        data.email = email;
        url = 'fbcc/payment/create';
    }
    if (userId) {
        data.user_id = userId;
    }
    if (projectId) {
        data.company_id = projectId;
    }
    return axios.request({
        url,
        method: 'post',
        data,
    });
};

// 获取推广奖励列表
export const getPromote = (page: number = 1, pageSize: number = 20, type: string) => {
    const params: any = {
        page,
        page_size: pageSize,
    };
    if (type) {
        params.type = type;
    }
    return axios.request({
        url: 'sys/user/user/get-user-turnover',
        method: 'get',
        params,
    });
};

// 获取流水类型
export const getThurnoverInfo = (id: string, type: string) => axios.request({
    url: 'sys/admin/company/get-turnover-info',
    methods: 'get',
    params: {
        id,
        type,
    },
});

// 获取open信息
export const getCompanyConfig = (type: string[]) => axios.request<Response<any>>({
    url: 'sys/company/company/get-company-config',
    method: 'get',
    params: {
        type: type.join(','),
    },
    // mock: true,
});

export interface TranslationNumWarningRes {
    // 是否需要告警
    is_waring: '0' | '1',
    // 消耗额度
    diff_num: string;
    // 告警翻译额度
    warning_translation_num: string;
    // 当前翻译额度
    translate_num: string;
    // 免费翻译额度更新时间
    date_y_m: string;
}

// 获取AI助理积分警告配置
export const getTranslationNumWarning = () => axios.request<Response<TranslationNumWarningRes>>({
    url: 'sys/company/company/get-translation-num-warning',
    method: 'get',
    params: {},
    customTips: true,
});

export const getCompanyWithdrawMoney = ({
    type, money, projectName, alipayAccountNumber, alipayName, administratorsEmail,
}: Witdhdraw) => {
    const data = {
        type,
        money,
        company_name: projectName,
        alipay_account_number: alipayAccountNumber,
        alipay_name: alipayName,
        administrators_email: administratorsEmail,
    };
    return axios.request({
        url: '/sys/admin/balance/self-withdrawal',
        method: 'post',
        data,
    });
};

export interface UpdateCompanyParams {
    remoteLoginRemind?: string;
    taskRetry?: string;
    recordCache?: string;
    openfbTab?: string;
    lumautoProxy?: string;
    oxylabsautoProxy?: string;
    ipAutoProxy?: string;
    openCookie?: string;
    openFbBookmarks?: string;
    luminatiSession?: string;
    fbNetworkAccelerationTask?: string;
    fbNetworkAccelerationOpen?: string;
    accountPlatform?: string;
    customIcon?: string;
    bookmark?: string;
    browserSecurityLock?: string;
    ignoreAgent?: string;
    openGoogleApi?: string;
    // applicationCenterSwitch?: string;
    dataReport?: string;
    timezone?: string;
    proxytype?: string;
    proxyinfo?: string;
    authorizationType?: string;
    common_words?: '0' | '1';
    browser_notice?: string;
    chat_wechat_notice_push?: string;
    sound_notice?: string;
    auto_assign?: string;
    end_session_confirm?: string;
    auto_reply?: string;
    robot_auto_reply?: string;
    auto_end_session?: string;
    plugin_remove_logo?: '0' | '1';
    email_remove_logo?: '0' | '1';
    auto_assign_rules?: string;
    chat_offline_default_channel?: string;
    chat_robot_wechat_push?: string;
    chat_new_message_notice_switch?: string;
    robot_assign_switch?: string;
    customer_email_notice_switch?: string;
    customer_email_notice_config?: string;
    client_message_notice?: string;
    sdk_message_notice?: string;
    remote_technical_support?: '0' | '1';
    check_whatsapp_protocol?: '0' | '1';
    view_unassign?: '0' | '1';
    sync_contact_create_session?: '0' | '1',
    timeout_no_response_notification?: string;
    specify_guest_language?: string;
    auto_recognize_language?: '0' | '1';
    translate_way?: string;
    auto_end_session_config?: string;
    version?: string;
    auto_translate?: '0' | '1',
    auto_translate_send?: '0' | '1',
    auto_translate_preview?: '0' | '1',
    unreply_session?: string;
    end_session_invite_evaluation?: '0' | '1';
    invite_evaluation_limit?: '0' | '1';
    translation_num_warning?: { enable_status: '0' | '1'; translation_num: number; };
    email_translate_way?: string; // ai 邮箱翻译方式
    auto_ai_detect_language?: '0' | '1';
    auto_remove_project?: '0' | '1'; // 是否开启自动注销
}

const requestCompanyConfigUpdate = (url: string, {
    remoteLoginRemind,
    taskRetry,
    recordCache,
    openfbTab,
    lumautoProxy,
    oxylabsautoProxy,
    ipAutoProxy,
    openCookie,
    openFbBookmarks,
    luminatiSession,
    fbNetworkAccelerationTask,
    fbNetworkAccelerationOpen,
    accountPlatform,
    customIcon,
    bookmark,
    browserSecurityLock,
    ignoreAgent,
    openGoogleApi,
    // applicationCenterSwitch,
    dataReport,
    timezone,
    proxytype,
    proxyinfo,
    authorizationType,
    common_words,
    browser_notice,
    chat_wechat_notice_push,
    sound_notice,
    auto_assign,
    end_session_confirm,
    auto_reply,
    robot_auto_reply,
    auto_end_session,
    plugin_remove_logo,
    email_remove_logo,
    auto_assign_rules,
    chat_offline_default_channel,
    chat_robot_wechat_push,
    chat_new_message_notice_switch,
    robot_assign_switch,
    customer_email_notice_switch,
    customer_email_notice_config,
    client_message_notice,
    sdk_message_notice,
    remote_technical_support,
    check_whatsapp_protocol,
    view_unassign,
    sync_contact_create_session,
    timeout_no_response_notification,
    specify_guest_language,
    auto_recognize_language,
    translate_way,
    auto_end_session_config,
    version,
    auto_translate,
    auto_translate_send,
    auto_translate_preview,
    unreply_session,
    end_session_invite_evaluation,
    invite_evaluation_limit,
    translation_num_warning,
    email_translate_way,
    auto_ai_detect_language,
    auto_remove_project,
}: UpdateCompanyParams) => {
    const data: any = {};
    if (timezone) {
        data.time_zone = timezone;
    }
    if (proxytype) {
        data.proxy_type = proxytype;
    }
    if (proxyinfo) {
        data.proxy_info = proxyinfo;
    }
    if (dataReport) {
        data.data_report = dataReport;
    }
    if (remoteLoginRemind) {
        data.remote_login_remind = remoteLoginRemind;
    }
    if (taskRetry) {
        data.task_retry = taskRetry;
    }
    if (recordCache) {
        data.record_cache = recordCache;
    }
    if (openfbTab) {
        data.openfb_tab = openfbTab;
    }
    if (ipAutoProxy) {
        data.ip_auto_proxy = ipAutoProxy;
    }
    if (lumautoProxy) {
        data.lumauto_proxy = lumautoProxy;
    }
    if (oxylabsautoProxy) {
        data.oxylabsauto_proxy = oxylabsautoProxy;
    }
    if (openCookie) {
        data.openfb_cookie = openCookie;
    }
    if (openFbBookmarks) {
        data.openfb_bookmarks = openFbBookmarks;
    }
    if (browserSecurityLock) {
        data.browser_security_lock = browserSecurityLock;
    }
    if (luminatiSession) {
        data.luminati_session = luminatiSession;
    }
    if (fbNetworkAccelerationTask) {
        data.fb_network_acceleration_task = fbNetworkAccelerationTask;
    }
    if (fbNetworkAccelerationOpen) {
        data.fb_network_acceleration_open = fbNetworkAccelerationOpen;
    }
    if (customIcon) {
        data.custom_icon = customIcon;
    }
    if (openGoogleApi) {
        data.open_google_api = openGoogleApi;
    }
    if (authorizationType) {
        data.authorization_type = authorizationType;
    }
    // if (applicationCenterSwitch) {
    //     data.application_center_switch = applicationCenterSwitch;
    // }
    if (bookmark !== undefined) {
        data.browser_bookmarks = bookmark;
    }
    if (ignoreAgent !== undefined) {
        data.ignore_agent_config = JSON.stringify(ignoreAgent.split('\n'));
    }
    if (common_words) {
        data.common_words = common_words;
    }
    if (browser_notice) {
        data.browser_notice = browser_notice;
    }
    if (chat_wechat_notice_push) {
        data.chat_wechat_notice_push = chat_wechat_notice_push;
    }
    if (sound_notice) {
        data.sound_notice = sound_notice;
    }
    if (auto_assign) {
        data.auto_assign = auto_assign;
    }
    if (end_session_confirm) {
        data.end_session_confirm = end_session_confirm;
    }
    if (auto_reply) {
        data.auto_reply = auto_reply;
    }
    if (robot_auto_reply) {
        data.robot_auto_reply = robot_auto_reply;
    }
    if (auto_end_session) {
        data.auto_end_session = auto_end_session;
    }
    if (email_remove_logo) {
        data.email_remove_logo = email_remove_logo;
    }

    if (plugin_remove_logo) {
        data.plugin_remove_logo = plugin_remove_logo;
    }

    if (auto_assign_rules) {
        data.auto_assign_rules = auto_assign_rules;
    }

    if (chat_offline_default_channel) {
        data.chat_offline_default_channel = chat_offline_default_channel;
    }

    if (chat_robot_wechat_push) {
        data.chat_robot_wechat_push = chat_robot_wechat_push;
    }

    if (chat_new_message_notice_switch) {
        data.chat_new_message_notice_switch = chat_new_message_notice_switch;
    }

    if (robot_assign_switch) {
        data.robot_assign_switch = robot_assign_switch;
    }

    if (customer_email_notice_switch) {
        data.customer_email_notice_switch = customer_email_notice_switch;
    }

    if (customer_email_notice_config) {
        data.customer_email_notice_config = customer_email_notice_config;
    }

    if (client_message_notice) {
        data.client_message_notice = client_message_notice;
    }

    if (sdk_message_notice) {
        data.sdk_message_notice = sdk_message_notice;
    }

    if (remote_technical_support) {
        data.remote_technical_support = remote_technical_support;
    }

    if (check_whatsapp_protocol) {
        data.check_whatsapp_protocol = check_whatsapp_protocol;
    }

    if (view_unassign) {
        data.view_unassign = view_unassign;
    }

    if (sync_contact_create_session) {
        data.sync_contact_create_session = sync_contact_create_session;
    }

    if (timeout_no_response_notification) {
        data.timeout_no_response_notification = timeout_no_response_notification;
    }

    // 指定访客语言
    if (specify_guest_language) {
        data.specify_guest_language = specify_guest_language;
    }

    // 自动识别语言
    if (auto_recognize_language) {
        data.auto_recognize_language = auto_recognize_language;
    }

    // 指定翻译线路
    if (translate_way) {
        data.translate_way = translate_way;
    }

    // 自动结束会话配置
    if (auto_end_session_config) {
        data.auto_end_session_config = auto_end_session_config;
    }

    if (version) {
        data.version = version;
    }

    // 自动翻译
    if (auto_translate) {
        data.auto_translate = auto_translate;
    }
    // 自动翻译
    if (auto_translate_send) {
        data.auto_translate_send = auto_translate_send;
    }
    // 自动翻译
    if (auto_translate_preview) {
        data.auto_translate_preview = auto_translate_preview;
    }

    // 在线聊天未回状态筛选设置
    if (unreply_session) {
        data.unreply_session = unreply_session;
    }

    // 结束会话自动邀评
    if (end_session_invite_evaluation) {
        data.end_session_invite_evaluation = end_session_invite_evaluation;
    }

    // 邀请评价限制单次评价
    if (invite_evaluation_limit) {
        data.invite_evaluation_limit = invite_evaluation_limit;
    }

    // AI助理积分预警配置
    if (translation_num_warning && translation_num_warning.enable_status && translation_num_warning.translation_num) {
        data.translation_num_warning = JSON.stringify(translation_num_warning);
    }

    if (email_translate_way) {
        data.email_translate_way = email_translate_way;
    }

    if (auto_ai_detect_language) {
        data.auto_ai_detect_language = auto_ai_detect_language;
    }

    if (auto_remove_project) {
        data.auto_remove_project = auto_remove_project;
    }

    // data.account_platform = accountPlatform;
    return axios.request({
        url,
        method: 'post',
        data,
        customTips: true,
    });
};

export const updateCompanyConfig = (params: UpdateCompanyParams) => requestCompanyConfigUpdate(
    'sys/company/company/update-company-config',
    params,
);

/**
 * 项目管理配置更新接口
 */
export const updateProjectManageConfig = (params: UpdateCompanyParams) => requestCompanyConfigUpdate(
    'sys/company/company/project-manage-config',
    params,
);

export interface ConsumeItem {
    user_num: string;
    plugin_num: string;
    telegram_num: string;
    email_num: string;
    label_num: string;
    flow_num: string;
    auto_reply_num: string;
    ai_reply_num: string;
    faq_num: string;
    port_num: string;
    whatsapp_app_port_num: string;
    telegram_app_port_num: string;
}

export interface PackageItem extends ConsumeItem {
    base_fee: string;
    user_num_fee: string;
    plugin_num_fee: string;
    telegram_num_fee: string;
    email_num_fee: string;
    label_num_fee: string;
    flow_num_fee: string;
    auto_reply_num_fee: string;
    ai_reply_num_fee: string;
    faq_num_fee: string;
}

export interface ConsumeInfoRes {
    project_info: {
        balance_day: string;
        package: string;
        package_fee: string;
    };

    consume_info: ConsumeItem;

    package_info: PackageItem;
}

// 获取项目消耗详情
export const getConsumeInfo = () => axios.request<Response<ConsumeInfoRes>>({
    url: 'sys/company/company/get-consume-info',
    method: 'get',
});

// 检查套餐使用情况
export const checkConsumeInfo = (params: {fields: string}) => axios.request<Response<{
    [index:string]: any;
}>>({
    url: 'sys/company/company/check-consume-info',
    method: 'post',
    params,
});

export interface WalletConsumeInfo {
    balance: string; // 余额
    all_recharge: string; // 累计充值
    all_consume: string; // 累计消耗
    whatsapp_consume: string; // whatsapp消耗
    amount_consume: string; // 额度消耗
    package_consume: string; // 套餐消耗
}

/**
 * 获取钱包余额消耗详情
 */
export const getWalletConsumeInfo = () => axios.request<Response<WalletConsumeInfo>>({
    url: 'sys/company/company/get-wallet-consume-info',
    method: 'get',
});

interface GetBillingFlowParams {
    page?: string;
    page_size?: string;
    order_time?: {
        start: string;
        end: string;
    }
    order_type?: string; // 'RECHRAGE' | 'SOFTWARE' | 'TRANSLATE' | 'EMAIL'
}

interface BillingFlowItem {
    money: string; // 支付金额
    wallet_money: string; // 余额支付的金额
    pay_type: string; // 支付类型
    pay_time: string; // 支付时间
    order_detail: {
        type: 'PACKAGE_MONTH' | 'UPDATE_PACKAGE' | 'PURCHASE_AMOUNT' | 'PURCHASE_ACCOUNT' | 'WALLET_RECHARGE'; // 订单购买类型 PACKAGE_MONTH 购买长期套餐 UPDATE_PACKAGE 更改套餐 PURCHASE_AMOUNT 购买额度 PURCHASE_ACCOUNT 购买账号 WALLET_RECHARGE 钱包充值
        money: string; // 支付金额
        account_num: string; // 购买whatsapp账号数
        days: string; // 购买使用天数
        channel_num: string; // 购买渠道总数
        user_num: string; // 购买坐席总数
        package: string; // 项目套餐类型
        send_email_num: string; // 购买邮件发送数
        translate_num: string; // 购买邮件翻译数
    };
}

interface BillingFlowList {
    page?: string;
    page_size?: string;
    list: BillingFlowItem[];
}

/**
 * 获取项目账单流水列表
 * @param params
 */
export const getBillingFlowList = (params: GetBillingFlowParams) => axios.request<Response<BillingFlowList>>({
    url: '/sys/project/billing/get-billing-flow',
    method: 'get',
    params,
});

export const getBillingFlowCount = (params: GetBillingFlowParams) => axios.request<Response<{total: string}>>({
    url: '/sys/project/billing/get-billing-flow-count',
    method: 'get',
    params,
});

interface GetConsumeParams {
    page?: string;
    page_size?: string;
    from_date?: {
        start: string;
        end: string;
    }
}

interface TranslateConsumeItem {
    dt?: string; // 消耗时间
    msg_translate_num?: string; // 文本翻译消耗
    speech_text_num?: string; // 语音转译消耗
    updated_time?: string; // 更新时间
    translate_msg_num?: string; // 翻译消息数
    speech_duration?: string; // 语音转译时长
}

interface ConsumeList {
    page?: string;
    page_size?: string;
    list: TranslateConsumeItem[];
}

/**
 * 获取项目翻译消耗明细列表
 * @param params
 */
export const getConsumeList = (params: GetConsumeParams) => axios.request<Response<ConsumeList>>({
    url: '/sys/company/translate/consume-list',
    method: 'get',
    params,
});

/**
 * 获取项目翻译消耗明细总数
 * @param params
 */
export const getConsumeCount = (params: GetConsumeParams) => axios.request<Response<{total: string}>>({
    url: '/sys/company/translate/consume-count',
    method: 'get',
    params,
});

interface EdmConsumeItem {
    dt?: string; // 消耗时间
    msg_translate_num?: string; // 邮件edm消耗
    updated_time?: string; // 更新时间
}

interface EdmConsumeList {
    page?: string;
    page_size?: string;
    list: EdmConsumeItem[];
}

/**
 * 获取项目邮件EDM翻译消耗明细列表
 * @param params
 */
export const getEdmConsumeList = (params: GetConsumeParams) => axios.request<Response<EdmConsumeList>>({
    url: '/sys/company/email/consume-list',
    method: 'get',
    params,
});

/**
 * 获取项目邮件EDM翻译消耗明细总数
 * @param params
 */
export const getEdmConsumeCount = (params: GetConsumeParams) => axios.request<Response<{total: string}>>({
    url: '/sys/company/email/consume-count',
    method: 'get',
    params,
});

export interface ExpenseBillRes {
    order_id: string;
    pay_time: string;
    pay_time_ymd_hms: string;
    pay_time_fjy: string;
    pay_money: string;
    details: {
        type: string;
        money: string;
    }[];
    payeeInfo: {
        recevier: string;
        address: string;
        bank_name: string;
        usd_account_no: string;
        swift_code: string;
        beneficiary_bankadd: string;
        bank_code: string;
        branch_code: string;
        name: string;
        email: string;
    }
}

/**
 * 获取费用清单
 * @param params
 * @returns
 */
export const getExpenseBillData = (params: { order_id: string }) => axios.request<Response<ExpenseBillRes>>({
    url: '/sys/project/order/get-expense-bill-data',
    method: 'get',
    params,
});

interface FetchLoginLogParams {
    page?: string;
    page_size?: string;
    login_time?: {
        start: string;
        end: string;
    }
    sys_user_id?: string;
}

export interface LoginLogItem {
    login_type: string; // 登录类型
    country: string; // 国家
    city: string; // 城市
    login_time: string; // 登录时间
    client_type: string; // 登录终端
    nickname: string; // 昵称
    ua_info: any; // ua信息
    login_ip: string;
}

export interface fetchLoginLogList {
    list: LoginLogItem[];
    page: string;
    page_size: string;
}

/**
 * 获取登录日志列表
 * @param params
 */
export const getLoginLogList = (params: FetchLoginLogParams) => axios.request<Response<fetchLoginLogList>>({
    url: '/sys/project/project/get-login-log',
    method: 'get',
    params,
});

/**
 * 获取登录日志列表总数
 * @param params
 */
export const getLoginLogCount = (params: FetchLoginLogParams) => axios.request<Response<{ total: string }>>({
    url: '/sys/project/project/get-login-log-count',
    method: 'get',
    params,
});

/**
 * 获取推荐档案配置
 * @param type
 * @returns
 */
export const getCompanyConfigDataFormat = (type: string[]) => axios.request({
    url: '/sys/company/company/get-company-config-data-format',
    method: 'get',
    params: {
        type: type.join(','),
    },
});

/**
 * 项目api或webhook的token配置
 * @param data
 */
export const updateTokenConfig = (data: { type: 'WEBHOOK_CONFIG' | 'DATA_SECRET' }) => axios.request<Response<{ secret: string }>>({
    url: '/sys/company/company/update-token-config',
    method: 'post',
    data,
});
interface WebhookConfigItem {
    address?: string;
    channel?: string;
}

/**
 * 项目配置webhook回调地址
 * @param data
 */
export const updateWebhookAddress = (data?: WebhookConfigItem) => axios.request<Response<{}>>({
    url: '/sys/company/company/update-webhook-address',
    method: 'post',
    data,
});

/**
 * 检查项目是否是webhook白名单
 */
export const checkWebhookWhiteList = () => axios.request<Response<{ is_white: string }>>({
    url: '/sys/company/company/get-webhook-white-list',
    method: 'get',
});
export interface customFieldItem {
    id?: string,
    field_name: string,
    custom_diy_field: string,
    name?: string;
    mongo_field_key?: string;
    field_type: '0' | '1' | '2' | '3', // 字段类型 0文本，1选择, 2日期，3数字
    select_type: '0' | '1', // 选项类型 0单选，1多选
    enable_status?: string, // 启用状态
    updated_time?: string, // 修改时间
    key?: string,
    sort_num: string, // 排序
    select_content: { // 选项内容 id=0和不存在的id为新增，编辑id不变
        id: string,
        value: string,
    }[],
}

export interface customFieldListRes {
    list: customFieldItem[],
    page: number,
    page_size: number,
}

/**
 * 获取自定义字段列表
 * @param data
 */
export const getCustomFieldList = (data: {
    page: number,
    page_size: number
 }) => {
    return axios.request<Response<customFieldListRes>>({
        url: '/sys/company/company/get-custom-field-list',
        method: 'post',
        data,
    });
};

/**
 * 获取自定义字段总数
 * @param data
 */
export const getCustomFieldListCount = (data: {
    page: number,
    page_size: number
}) => {
    return axios.request<Response<{ total: number }>>({
        url: '/sys/company/company/get-custom-field-count',
        method: 'post',
        data,
    });
};

/**
 * 编辑自定义字段
 * @param data
 */
export const updateCustomField = (data: customFieldItem) => axios.request<Response<any>>({
    url: '/sys/company/company/update-custom-field',
    method: 'post',
    data,
});

/**
 * 启用/关闭自定义字段
 * @param data
 */
export const enableCustomField = (data: {
    id: string,
    enable_status: '0' | '1', // 启用状态 0.关闭 1.启用
}) => axios.request<Response<any>>({
    url: '/sys/company/company/enable-custom-field',
    method: 'post',
    data,
});

/**
 * 删除自定义字段
 * @param data
 */
export const delCustomField = (data: {
    id: string,
}) => axios.request<Response<any>>({
    url: '/sys/company/company/del-custom-field',
    method: 'post',
    data,
});

/**
 * 获取自定义字段
 * @param data
 */
export const getCustomField = (params: {
    id: string,
}) => axios.request<Response<customFieldItem>>({
    url: '/sys/company/company/get-custom-field',
    method: 'get',
    params,
});

/**
 * 获取开启的自定义字段
 * @param data
 */
export const getEnableCustomFields = () => axios.request<Response<customFieldListRes>>({
    url: '/sys/company/company/get-enable-custom-fields',
    method: 'post',
});

/**
 * 修改自定义排序
 * @param data
 */
export const updateCustomFieldSort = (data: { id: string, sort_num: number, }) => axios.request({
    url: '/sys/company/company/update-custom-field-sort',
    method: 'post',
    data,
});

export interface HelpdeskList {
    id: string;
    name: string;
    domain: string;
    add_time: string;
}

interface HelpdeskListData {
  list: HelpdeskList[];
  page: number;
  page_size: number;
}

interface HelpdeskListParams {
    page: number;
    page_size: number;
}

/**
 * 获取helplook知识库列表
 * @returns
 */

export const getHelpdeskList = () => axios.request<Response<HelpdeskListData>>({
    url: '/sys/company/company/get-knowledge-base-list',
    method: 'get',
});

type RedirectTo = 'home' | 'agent' // home-知识库 agent-智能体

/**
 * 获取helplook知识库跳转url
 * @returns
 */
export const getHelpBotsUrl = (redirect_to: RedirectTo = 'home', ai_employee_user_id?: string) => axios.request<Response<{redirect_url: string}>>({
    url: '/sys/company/company/get-help-desk-url',
    method: 'get',
    params: { redirect_to, ai_employee_user_id },
});

interface GPTBotListData {
    list: {
        name: string;
        bot_id: string;
        logo: string;
        introduction: string;
        bot_type: string;
        chat_model_version_id: string;
    };
}

/**
 * 获取 GPTBots 应用信息
 */
export const getGPTBotsDetail = (api_key: string) => axios.request<Response<GPTBotListData>>({
    url: '/sys/company/company/get-gptbots-detail',
    method: 'get',
    params: {
        api_key,
    },
});

/**
 * 获取 Dify 应用信息
 */
export const getDifyDetail = (api_key: string) => axios.request<Response<GPTBotListData>>({
    url: '/sys/company/company/get-dify-detail',
    method: 'get',
    params: {
        api_key,
    },
});

interface GPTRandomTokenData {
    token: string;
}

type GetRandomTokenParams = {
    project_id?: string;
}

/**
 * 自定义机器人获取随机token
 */
export const getRandomToken = (params?: GetRandomTokenParams) => axios.request<Response<GPTRandomTokenData>>({
    url: '/sys/company/company/get-random-token',
    method: 'get',
    params,
});

interface RemoveProjectData {
    verify_ticket: string;
    verify_randstr: string;
}

/**
 * 注销项目接口
 * @param data
 */
export const removeProject = (data: RemoveProjectData) => axios.request({
    url: '/sys/company/company/remove-project',
    method: 'post',
    data,
});
